var _a;
/**
 * Static class that allows adding new media queries to listen to or subscribe/unsubscribe from existing ones.
 * It uses the window.matchMedia API to listen to media query changes (which is more performant than listening to window resize events).
 */
export class MediaQueryListener {
}
_a = MediaQueryListener;
MediaQueryListener._subscribers = {};
MediaQueryListener._eventListenersRefs = {};
/**
 * Subscribe by passing a callback and the media query to listen to in a string format.
 * It will also instantly call the subscriber with the current state of the media query.
 *
 * @param cb - callback function to be called when the media query match changes
 * @param query - media query to listen to (default is '(max-width: 768px)')
 */
MediaQueryListener.subscribe = (cb, query = '(max-width: 768px)') => {
    var _b, _c, _d, _e;
    if (!_a._subscribers[query]) {
        _a._subscribers[query] = {
            query: (_b = window.matchMedia) === null || _b === void 0 ? void 0 : _b.call(window, query),
            subscribers: [cb],
        };
        _a._eventListenersRefs[query] = event => {
            _a._subscribers[query].subscribers.forEach(subscriber => subscriber(event.matches));
        };
        _a._subscribers[query].query.addEventListener('change', _a._eventListenersRefs[query]);
    }
    else {
        _a._subscribers[query].subscribers.push(cb);
    }
    // Call the callback with the current value of the media query
    cb((_e = (_d = (_c = window.matchMedia) === null || _c === void 0 ? void 0 : _c.call(window, query)) === null || _d === void 0 ? void 0 : _d.matches) !== null && _e !== void 0 ? _e : false);
};
/**
 * Unsubscribe by passing the callback and the media query to stop listening to in a string format.
 *
 * Also handles memory leaks by removing the event listener when there are no more subscribers so don't forget
 * to call unsubscribe when you're done (best place should be in `disconnectedCallback` lifecycle method of the component).
 *
 * @param cb - callback function to be called when the media query match changes
 * @param query - media query to listen to (default is '(max-width: 768px)')
 */
MediaQueryListener.unsubscribe = (cb, query = '(max-width: 768px)') => {
    if (!_a._subscribers[query]) {
        return;
    }
    _a._subscribers[query].subscribers = _a._subscribers[query].subscribers.filter(subscriber => subscriber !== cb);
    if (_a._subscribers[query].subscribers.length === 0) {
        _a._subscribers[query].query.removeEventListener('change', _a._eventListenersRefs[query]);
        delete _a._subscribers[query];
        delete _a._eventListenersRefs[query];
    }
};
/**
 * Get the current state of a media query without subscribing to changes.
 *
 * @param query - media query to check (default is '(max-width: 768px)')
 * @returns boolean indicating whether the media query matches or not
 */
MediaQueryListener.getSnapshot = (query = '(max-width: 768px)') => { var _b, _c, _d; return (_d = (_c = (_b = window.matchMedia) === null || _b === void 0 ? void 0 : _b.call(window, query)) === null || _c === void 0 ? void 0 : _c.matches) !== null && _d !== void 0 ? _d : false; };
